import { BaseRecord } from "@refinedev/core";

export enum PurchaseRequestStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  IN_PROCUREMENT = 'IN_PROCUREMENT',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum ApprovalStepStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface PlanItemRef {
  planId?: string;
  itemId?: string;
}

export interface RequestItem extends BaseRecord {
  id: string;
  name: string;
  description?: string;
  quantity: number;
  requestedQty: number;
  inSourcingQty: number;
  awardedQty: number;
  orderedQty: number;
  receivedQty: number;
  unit?: string;
  categoryType?: string;
  productCategory?: string;
  unitPrice: number;
  totalPrice: number;
  supplier?: string;
  specifications?: string;
  planRef?: PlanItemRef;
  priority?: string;
  justification?: string;
  tags?: string[];
}

export interface Approval {
  order: number;
  roleSlug: string;
  stepName?: string;
  approvedBy?: string;
  approvedOn?: Date;
  remarks?: string;
  stepStatus: ApprovalStepStatus;
}

export interface Attachment {
  fileId: string;
  originalName: string;
  mimeType: string;
  size: number;
}

export interface BudgetValidation {
  validatedAt: Date;
  validatedBy?: string;
  remarks?: string;
  totalAmount: number;
}

export enum Currency {
  ETB = 'ETB',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum PaymentTerms {
  NET_30 = 'NET_30',
  NET_60 = 'NET_60',
  PAYMENT_ON_DELIVERY = 'PAYMENT_ON_ADVANCE',
  ADVANCE_PAYMENT = 'ADVANCE_PAYMENT',
  NET_15 = 'NET_15',
  NET_90 = 'NET_90',
}

export enum ShippingMethod {
  SUPPLIER_DELIVERY = 'SUPPLIER_DELIVERY',
  CUSTOMER_PICKUP = 'CUSTOMER_PICKUP',
  THIRD_PARTY_SHIPPER = 'THIRD_PARTY_SHIPPER',
}

export enum ShippingCarrierType {
  AIR = 'AIR',
  SURFACE = 'SURFACE',
  OCEAN = 'OCEAN',
}

export interface ShippingInfo {
  method: ShippingMethod;
  carrierType?: ShippingCarrierType;
  carrierName?: string;
  trackingNumber?: string;
  shippingAddress?: string;
  shippingCost?: number;
  specialInstructions?: string;
}

export interface VendorContact {
  vendorId: string;
  companyName: string;
  contactPerson?: string;
  email?: string;
  phone?: string;
  address?: string;
  tin?: string;
}

export interface PurchaseRequest extends BaseRecord {
  id: string;
  requestNo: string;
  title?: string;
  description?: string;
  isUnplanned?: boolean;
  templateId?: string;
  teamId: string;
  dateRequested: Date;
  dateRequired: Date;
  createdBy?: string;
  updatedBy?: string;
  requestedBy?: string;
  budgetSource?: string;
  budgetId?: string;
  items: RequestItem[];
  totalAmount: number;
  attachments?: Attachment[];
  status: PurchaseRequestStatus;
  approvals?: Approval[];
  budgetValidation?: BudgetValidation;
  tags?: string[];
  notes?: string;
  vendor?: VendorContact;
  currency?: Currency;
  paymentTerms?: PaymentTerms;
  shippingInfo?: ShippingInfo;
  termsAndConditions?: string;
  approvalType?: string;
  steps?: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
  }>;
  externalWorkflow?: Record<string, any>;
  flowCaseId?: string;
  flowCaseNumber?: string;
  submittedBy?: string;
  assignedTo?: string;
  assignedBy?: string;
  assignedOn?: Date;
  createdAt: Date;
  updatedAt: Date;
}